/** @jsx h */
import { h } from 'preact'

const ShareIcon = ({
  style = {},
  fill = '#054060',
  stroke = '#757575',
  width = '17.128',
  height = '20',
  className = '',
  viewBox = '0 0 17.128 20'
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`rcc_c_share-icon ${className}`}
    aria-hidden='true'
  >
    <g transform='translate(-336.911 -524.878)' fill='none' strokeMiterlimit='10'>
      <path
        d='M345.91,528.2a8.578,8.578,0,0,1,.994.062v-3.384l7.135,5.992-7.135,5.992V533.3a5.7,5.7,0,0,0-.872-.078,6.814,6.814,0,0,0-4.8,11.658A8.992,8.992,0,0,1,345.91,528.2Z'
        stroke='none'
      />
      <path
        d='M 347.9039916992188 527.0236206054688 L 347.9039916992188 528.2620239257812 L 347.9039916992188 529.385009765625 L 346.7885131835938 529.2553100585938 C 346.4683532714844 529.2180786132812 346.1809997558594 529.2000122070312 345.9100036621094 529.2000122070312 C 341.4993591308594 529.2000122070312 337.9110107421875 532.7879028320312 337.9110107421875 537.197998046875 C 337.9110107421875 537.96533203125 338.0216674804688 538.7258911132812 338.2364501953125 539.4549560546875 C 338.5351257324219 535.4153442382812 341.9174194335938 532.219970703125 346.0320129394531 532.219970703125 C 346.4243774414062 532.219970703125 346.7855529785156 532.2678833007812 347.0563659667969 532.3096313476562 L 347.9039916992188 532.4403076171875 L 347.9039916992188 533.2979736328125 L 347.9039916992188 534.71630859375 L 352.4840393066406 530.8699951171875 L 347.9039916992188 527.0236206054688 M 346.9039916992188 524.8779907226562 L 354.0390014648438 530.8699951171875 L 346.9039916992188 536.8619995117188 L 346.9039916992188 533.2979736328125 C 346.6189880371094 533.2540283203125 346.3299865722656 533.219970703125 346.0320129394531 533.219970703125 C 342.2669982910156 533.219970703125 339.2149963378906 536.27197265625 339.2149963378906 540.0369873046875 C 339.2149963378906 541.9310302734375 339.989013671875 543.6420288085938 341.2359924316406 544.8779907226562 C 338.64599609375 543.2979736328125 336.9110107421875 540.4539794921875 336.9110107421875 537.197998046875 C 336.9110107421875 532.22900390625 340.9400024414062 528.2000122070312 345.9100036621094 528.2000122070312 C 346.2470092773438 528.2000122070312 346.5769958496094 528.2239990234375 346.9039916992188 528.2620239257812 L 346.9039916992188 524.8779907226562 Z'
        stroke='none'
        fill={fill}
      />
    </g>
  </svg>
)

export default ShareIcon
